export const requirements = {
  marqetaOnly: true,
};

// placeholder until we figure out what this is.
export const verifier = () => {
  return false;
};
